// @ts-nocheck
/* eslint-disable */

"use client";

import {
  BlogCard,
  Button,
  Column,
  EmptyState,
  Flex,
  Icon,
  Loader,
  Row,
} from "tempdev-ds";
import { Suspense, useEffect, useState } from "react";

import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import Link from "next/link";
import NavigationEvents from "@/components/common/NavigationEvents/NavigationEvents";
import { WpClientRequest } from "@/lib/wordpress/wpClientRequest";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";
import { formatDate } from "@/lib/helpers/dateFormate";
import { useGlobalContext } from "@/lib/globalContext";

const BlogPage = (post: Record<string, unknown>) => {
  const blocks = post?.blocks?.slice(1);
  const intro = post?.blocks && post?.blocks[0];

  const [loading, setLoading] = useState<boolean | null>(false);
  const [filters, setFilters] = useState<IFilters | null>();
  const [filteredPosts, setFilteredPosts] = useState<
    Record<string, unknown>[] | null
  >();

  const state = useGlobalContext();

  useEffect(() => {
    if (!filters) {
      setFilteredPosts();
    } else {
      setLoading(true);

      WpClientRequest({
        post_type: "post",
        variables: {
          ...filters,
          limit: 18,
        },
      }).then((res) => {
        setFilteredPosts(res.items);
        setLoading(false);
      });
    }
  }, [filters]);

  return (
    <div>
      <NavigationEvents />

      {displayBlock(intro as BlocksProps, 0)}

      <div className={"pt-6 pb-6 mb-8"}>
        <Row align="center">
          <Column>
            <Flex align="center" justify="center" style={{ gap: "8px" }}>
              <div className="custom-select">
                <span className="h6">{state?.dict?.search?.search}</span>
                <input
                  type="text"
                  name="search"
                  placeholder="Search for articles"
                  className="texts"
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      search: e.target.value,
                    });
                  }}
                />
                <Icon icon={"icon-search"} />
              </div>
              <div className="custom-select">
                <span className="h6">{state?.dict?.postTypes?.categories}</span>
                <select
                  className="texts"
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      category: e.target.value,
                    });
                  }}
                >
                  <option value={""}>
                    {state?.dict?.common?.chooseOption}
                  </option>
                  {post &&
                    post.categories &&
                    post.categories.map((category, i) => {
                      return (
                        <option
                          key={`${category.name}-i`}
                          value={category.id as string}
                        >
                          {category.name as string}
                        </option>
                      );
                    })}
                </select>
                <Icon icon={"icon-down"} />
              </div>
              <div className="custom-select">
                <span className="h6">{state?.dict?.postTypes?.tags}</span>
                <select
                  className="texts"
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      tag: e.target.value,
                    });
                  }}
                >
                  <option value={""}>
                    {state?.dict?.common?.chooseOption}
                  </option>
                  {post &&
                    post.tags &&
                    post.tags.map((tag, i) => {
                      return (
                        <option key={`${tag.name}-i`} value={tag.id as string}>
                          {tag.name as string}
                        </option>
                      );
                    })}
                </select>
                <Icon icon={"icon-down"} />
              </div>
            </Flex>
          </Column>
        </Row>
      </div>

      <Row>
        {loading ? (
          <Column className="text-center pt-5 pb-5">
            <Loader label={state?.dict?.common?.loading}></Loader>
          </Column>
        ) : (
          <>
            {filters ? (
              <Suspense
                fallback={
                  <Loader label={state?.dict?.common?.loading}></Loader>
                }
              >
                {filteredPosts && filteredPosts.length !== 0 ? (
                  filteredPosts.map(
                    (post: Record<string, unknown>, i: number) => {
                      if (!post) return false;

                      const category =
                        (post?.categories as Record<
                          string,
                          unknown | string
                        >) || [];
                      const categoryName =
                        category && category[0]
                          ? (category[0].name as string)
                          : "";
                      const imageElement = (
                        <DisplayImage
                          url={post?.image as string}
                          alt={post?.title ? (post?.title as string) : ""}
                          fill={true}
                        />
                      );

                      const author = post?.author
                        ? {
                            ...post?.author,
                            imageElement: (
                              <DisplayImage
                                url={post?.author?.img as string}
                                alt={
                                  post?.author?.name
                                    ? (post?.author?.name as string)
                                    : ""
                                }
                                fill={true}
                              />
                            ),
                            linkElement: (
                              <Link
                                href={post?.author?.slug as string}
                                className="linker"
                              ></Link>
                            ),
                          }
                        : {};

                      return (
                        <Column key={`blogCard-${i}`} sm={12} md={4}>
                          <BlogCard
                            date={formatDate(
                              post?.date as string,
                              "DATE_SHORT"
                            )}
                            category={categoryName}
                            imageElement={imageElement}
                            title={post.title}
                            description={post.excerpt}
                            author={author}
                            linkElement={
                              <Link
                                href={post.slug as string}
                                className="linker"
                              ></Link>
                            }
                          />
                        </Column>
                      );
                    }
                  )
                ) : (
                  <Column className="pt-5 pb-5">
                    <EmptyState
                      label={state?.dict?.common?.noResults}
                    ></EmptyState>
                  </Column>
                )}
              </Suspense>
            ) : (
              <>
                {!!blocks?.length &&
                  blocks.map((block: object, index: number) => {
                    return displayBlock(block as BlocksProps, index);
                  })}
              </>
            )}
          </>
        )}
      </Row>
    </div>
  );
};
export default BlogPage;
